/* eslint-disable global-require */

if (!process.env.BROWSER) {
  module.exports = require('../server/loaders');
} else {
  module.exports = require('../app/loaders');
}
